// SHARITI brand logo assets (rendered from the official artwork)
import { accentForText } from '@/lib/colors';

// Fixed SHARITI brand orange for the "FACE TO FACE" tagline — must NOT change
// with the selected association theme.
const SHARITI_ORANGE = accentForText('#EE722E');

export const SharitiMark = ({ className = 'h-9 w-9', white = false, alt = 'SHARITI' }) => (
  <img src={white ? '/shariti-mark-white.png' : '/shariti-mark.png'} alt={alt}
    className={`${className} object-contain select-none`} draggable={false} />
);

export const SharitiLockup = ({ white = false, size = 'md', tagline = true }) => {
  const markSize = size === 'lg' ? 'h-12 w-12' : size === 'sm' ? 'h-7 w-7' : 'h-9 w-9';
  const nameSize = size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-base' : 'text-lg';
  const ink = white ? '#FFFFFF' : 'var(--shariti-ink)';
  return (
    <div className="flex items-center gap-2.5">
      <SharitiMark white={white} className={markSize} />
      <div className="leading-none">
        <p className={`font-display font-bold tracking-tight ${nameSize}`} style={{ color: ink }}>SHARITI</p>
        {tagline && (
          <p className="mt-0.5 text-[10px] font-medium tracking-[0.22em]"
            style={{ color: white ? 'rgba(255,255,255,0.75)' : SHARITI_ORANGE }}>
            FACE TO FACE
          </p>
        )}
      </div>
    </div>
  );
};
